// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_BuscarMenuItensResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/menu_itens/buscar_menu_itens.
 *
 * Returns the full list of configured menu items (with status title and
 * hierarchy/sort columns) for the menu-items config screen.
 */
import type { MenuItens_BuscarMenuItensRow } from './MenuItens_BuscarMenuItensRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MenuItens_BuscarMenuItensResponseDados = MenuItens_BuscarMenuItensRow[];

export type MenuItens_BuscarMenuItensResponse = ApiResponse<MenuItens_BuscarMenuItensResponseDados>;

registerResponseContract('MenuItens_BuscarMenuItensResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      menu_item_id:            { type: 'number',  required: true },
      menu_item_titulo:        { type: 'string',  required: true },
      menu_item_tipo:          { type: 'string',  required: true },
      menu_item_icone:         { type: 'string',  required: true },
      menu_item_controller:    { type: 'string',  required: true },
      menu_item_url:           { type: 'string',  required: true },
      menu_item_pai_id:        { type: 'string',  required: true },
      menu_item_status:        { type: 'number',  required: true },
      menu_item_status_titulo: { type: 'string',  required: false },
      menu_item_ordem:         { type: 'number',  required: true },
      menu_item_permissoes:    { type: 'string',  required: true },
      menu_item_hierarquia:    { type: 'string',  required: true },
      sort_path:               { type: 'string',  required: true },
    },
  },
})
